// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin (webpack.config.js)
import QuestionsCard from "./QuestionsCard-APP_CLIENT.styled";

export default QuestionsCard;
